import 'bundles/show/videoTop';
import 'vendor/jquery.isOnScreen';

import { getLocale } from 'services/LocalizationService';

import { trackAction } from 'helpers/trackingOM';
import { useTimeZone } from 'helpers/timeZone';

import { ACCOUNT_SWITCH_BASE_URL } from 'vue/constants/svodRoutes';

import VideoHeroController from 'components/VideoHeroController';
import { formatTimeElements } from 'helpers/dates';

useTimeZone();

$(function () {
    // EdgeToEdgePlayer hide header (start)
    var movieStarted = false;

    var $movieDescription = $('.movie-description-box p');
    var readMoreActive = false;
    CBS.Promises.Tracking.onLoad(() => {
        initButtonTracking();
    });
    let heroVolume = $('.hero-volume');

    const videoHeroController = new VideoHeroController(heroVolume, null, 2000);

    function initButtonTracking() {
        $('.swiper-wrapper .swiper-slide .hero__content-slide-wrapper .button').on(
            'click',
            async function (event) {
                // Stop the marquee splice video.
                try {
                    await videoHeroController.destroyVideo();
                } catch (e) {}

                let aaLink = $(this).attr('aa-link').split('|');

                let __title = aaLink[4];
                __title = __title !== '' ? __title : window.__title;
                let __action = 'trackMovieHero';
                let __movieId = window.__content_id;
                if (aaLink[2] === 'Trailer') {
                    __action = 'trackWatchTrailer';
                }

                let __contentBrand = aaLink[10];
                __contentBrand = __contentBrand !== '' ? __contentBrand : 'na';

                let spliceEnabled = $('.marqueeVideo').length ? '1' : '0';

                if (typeof om != 'undefined') {
                    trackAction(__action, {
                        pageType: 'movie',
                        ctaText: aaLink[2].toLowerCase(), // example values of button texts that would pass would be “start watching”, “resume watching”, “watch now”, etc.
                        movieId: __movieId,
                        movieTitle: __title,
                        movieGenre: window.__genre,
                        spliceEnabled: spliceEnabled,
                        contentBrand: __contentBrand,
                        contentLocked: aaLink[23],
                        rowHeaderTitle: 'movie hero',
                    });
                }

                localStorage.setItem('trackMovieCta', aaLink[2].toLowerCase() ?? '');

                //Need to track state for new page view-- we don't load new page so want to trigger this tracking manually as though it was a new page.
                // For Movies only NOT TRAILERS
                if (aaLink[2] !== 'Trailer') {
                    if (typeof om != 'undefined') {
                        om.trackState({
                            pageType: 'video',
                            movieId: __movieId,
                            movieTitle: __title,
                            movieGenre: window.__genre,
                            spliceEnabled: spliceEnabled,
                            rowHeaderTitle: 'movie hero',
                        });
                    }
                }
            },
        );
    }

    function checkReadMore() {
        if ($movieDescription.length) {
            if (
                $movieDescription[0].clientHeight < $movieDescription[0].scrollHeight ||
                $movieDescription[0].clientWidth < $movieDescription[0].scrollWidth
            ) {
                $('#read-more').addClass('readMoreVisible');
            } else {
                if (readMoreActive == false) {
                    $('#read-more').removeClass('readMoreVisible');
                }
            }
        }
    }

    function playSplice() {
        if (window.location?.hash === '#open') {
            return;
        }

        const overlay = document.getElementsByClassName('overlayContainer');

        overlay[0]?.classList.add('spliceVid');
        videoHeroController.playSplice();
    }

    function trackSpliceComplete() {
        trackAction('trackSpliceComplete', {
            pageType: 'movie',
            movieSectionTitle: 'home',
            movieId: window.__content_id,
            movieTitle: utag_data.movieTitle,
            movieGenre: window.__genre,
            contentBrand: utag_data.contentBrand,
            spliceEnabled: '1',
        });
    }

    function trackSpliceView() {
        trackAction('trackSpliceView', {
            pageType: 'movie',
            movieSectionTitle: 'home',
            movieId: window.__content_id,
            movieTitle: utag_data.movieTitle,
            movieGenre: window.__genre,
            contentBrand: utag_data.contentBrand,
            spliceEnabled: '1',
        });
    }

    async function startMovie() {
        try {
            await videoHeroController.destroyVideo();
        } catch (e) {}

        if (CBS.Registry.user.sub_status !== '') {
            $('header').addClass('goUp dark');
            window.scrollTo(0, 0);
            $('.top-components,.movie-description-box').css('display', 'none');
            $('.video__player-area').css('display', 'block');
            if ($('.video__player-wrapper').length && window.location?.hash !== '#open') {
                window.history.pushState(null, null, '#open');
            }
        }

        if (typeof smartTagAPI !== 'undefined') {
            smartTagAPI.pageAction({ action: 'PageAction.START_PANEL_CLICK' });
        }
        movieStarted = true;
    }

    videoHeroController.trackingEndedCallback = trackSpliceComplete;
    videoHeroController.trackingPlayingCallback = trackSpliceView;

    if (CBS.Registry.Features.movie_detail_page == true) {
        playSplice();
    } else {
        $('header').css('visibility', 'hidden');
        movieStarted = true;
    }

    $(window).resize(function () {
        checkReadMore();
    });

    checkReadMore();

    $('#read-more').on('click', function () {
        readMoreActive = true;
        if ($(this).hasClass('less')) {
            var line = 5;
            $('.description p').css({ webkitLineClamp: line.toString() });
            $(this).removeClass('less');
            $(this).html(getLocale('read_more'));
        } else {
            var line = 100;
            $('.description p').css({ webkitLineClamp: line.toString() });
            $(this).addClass('less');
            $(this).html(getLocale('read_less'));
        }
    });

    const iPad =
        navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); /* iPad OS 13 */

    window.CBS.Registry.videopage = true;

    window.onpopstate = function (e) {
        e.preventDefault();
        if ($('.video__player-area').is(':visible')) {
            window.location.reload();
        }
    };

    if (window.location?.hash === '#open') {
        startMovie();
    }

    const movieCtaBtn = document.querySelector('a.watchMovieButton');

    movieCtaBtn?.addEventListener('click', (e) => {
        let href = e.currentTarget.getAttribute('href')?.trim();
        if (href && href.includes(ACCOUNT_SWITCH_BASE_URL)) {
            return;
        }
        startMovie();
    });

    if (!iPad) {
        //$('header').css('visibility','hidden');
        var timer1;
        var headerVisible = false;
        let win = $(window);
        let scrollPosition = 0;

        function hideMenu() {
            window.clearTimeout(timer1);
            if (document.getElementById('programming-alerts') !== null) {
                $('header').addClass('goUpWithAlert');
            } else {
                $('header').addClass('goUp');
            }
            $('#subnav').addClass('hideSubNav');
            $('.nav-link-container').addClass('hideBackToVideo');
            headerVisible = true;

            $('header').one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function (e) {
                    if (headerVisible) {
                        headerVisible = false;
                        $('header').css('visibility', 'hidden');
                        $('.skin-metadata-manager').css('visibility', 'visible');
                        $('.top-menu-manager').css('visibility', 'visible');
                    }
                },
            );
        }
        function showMenu() {
            $('header').css('visibility', 'visible');
            if (document.getElementById('programming-alerts') !== null) {
                $('header').removeClass('goUpWithAlert');
            } else {
                $('header').removeClass('goUp');
            }
            $('#subnav').removeClass('hideSubNav');
            $('.top-menu-hint').css('visibility', 'hidden');
            $('.top-menu-hint').css('opacity', 0);
            $('.top-menu-hint-bg').css('visibility', 'hidden');
            $('.top-menu-hint-bg').css('opacity', 0);

            $('.skin-metadata-manager').css('visibility', 'hidden');
            $('.top-menu-manager').css('visibility', 'hidden');
            $('header').addClass('dark');
        }

        function debounce(func, timeout = 250) {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    func.apply(this, args);
                }, timeout);
            };
        }

        $(window).scroll(function (e) {
            if (movieStarted === true) {
                let scrollTop = window.scrollY;
                scrollPosition = scrollTop;

                if (scrollTop >= 0) {
                    if (!headerVisible) {
                        showMenu();
                        //startMouseTimer();
                    }

                    if (scrollTop > 0) {
                        $('.nav-link-container').removeClass('hideBackToVideo');
                    } else {
                        hideMenu();
                        $('.nav-link-container').addClass('hideBackToVideo');
                    }
                }
            }
        });
        function startMouseTimer() {
            window.clearTimeout(timer1);
            timer1 = window.setTimeout(hideMenu, 3000);
        }

        $('.backToVideo').on('click', function () {
            window.scrollTo(0, 0);
        });

        $('.menu-link-container').on('mousemove', function () {
            showMenu();
            startMouseTimer();
        });

        $('.header__nav--items').on('mousemove', function () {
            if (movieStarted == true) {
                startMouseTimer();
            }
        });

        $('#global-header-container').on('mouseleave', function () {
            if (movieStarted == true) {
                if (scrollPosition == 0) {
                    hideMenu();
                }
            }
        });

        $('.video__player-area').on('mousemove', function () {
            clearTimeout($.data(this, 'mouseMoveTimer'));
            $('.top-menu-hint').css('visibility', 'visible');
            $('.top-menu-hint').css('opacity', 1);
            $('.top-menu-hint-bg').css('visibility', 'visible');
            $('.top-menu-hint-bg').css('opacity', 1);

            $.data(
                this,
                'mouseMoveTimer',
                setTimeout(function () {
                    $('.top-menu-hint').css('visibility', 'hidden');
                    $('.top-menu-hint').css('opacity', 0);
                    $('.top-menu-hint-bg').css('visibility', 'hidden');
                    $('.top-menu-hint-bg').css('opacity', 0);
                }, 3000),
            );
        });

        $('.video__player-area, #hero-content').on('mouseout', function () {
            if (scrollPosition == 0) {
                clearTimeout($.data(this, 'mouseMoveTimer'));
                $('.top-menu-hint').css('visibility', 'hidden');
                $('.top-menu-hint').css('opacity', 0);
                $('.top-menu-hint-bg').css('visibility', 'hidden');
                $('.top-menu-hint-bg').css('opacity', 0);
            }
        });
    } else {
        $('body').addClass('body-offset');
        $('#main-container').css('margin-top', '-56px');
        $('#subnav').removeClass('hideSubNav');
        if (document.getElementById('programming-alerts') !== null) {
            $('header').removeClass('goUpWithAlert');
        } else {
            $('header').removeClass('goUp');
        }
    }

    window.addEventListener('load', () => {
        const timeElement = document.querySelector('.movie__air-year');
        formatTimeElements(timeElement);
    });
});
